import React, { useEffect, useState } from 'react';
import twitterLogo from './assets/twitter-logo.svg';
import './App.css';
import SelectCharacter from './Components/SelectCharacter';
import { CONTRACT_ADDRESS, transformCharacterData } from './constants';
import myEpicGame from './utils/MyEpicGame.json';
import { ethers } from 'ethers';
import Arena from './Components/Arena';
import LoadingIndicator from './Components/LoadingIndicator';
import bgvideo from './assets/videobg.mp4';

// Constants
const TWITTER_HANDLE = 'stevedsimkins';
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;

const App = () => {

  // STATE 

  const [currentAccount, setCurrentAccount] = useState(null);

  const [characterNFT, setCharacterNFT] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  //Ethereum Functions
  const checkIfWalletIsConnected = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        console.log("Make sure you have MetaMask!");
        return;
      } else {
        console.log("We have the ethereum object", ethereum);

        const accounts = await ethereum.request({ method: 'eth_accounts' });

        if (accounts.length !== 0) {
          const account = accounts[0];
          console.log('Found an authorized account:', account);
          setCurrentAccount(account);
        } else {
          console.log('No authorized account found');
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const connectWalletAction = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        alert('Get MetaMask!');
        return;
      }

      const accounts = await ethereum.request({
        method: 'eth_requestAccounts',
      });

      console.log('Connected', accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (error) {
      console.log(error);
    }
  };

  //Use Effects 

  useEffect(() => {
    setIsLoading(false);
    checkIfWalletIsConnected();
  }, []);

  useEffect(() => {

    const fetchNFTMetadata = async () => {
      console.log('Checking for Character NFT on address:', currentAccount);

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const gameContract = new ethers.Contract(CONTRACT_ADDRESS, myEpicGame.abi, signer);

      const txn = await gameContract.checkIfUserHasNFT();
      if (txn.name) {
        console.log('User has character NFT');
        setCharacterNFT(transformCharacterData(txn));
        setIsLoading(false);
      } else {
        console.log('No Character NFT found');
        setIsLoading(false);
      }
    };

    if (currentAccount) {
      console.log('CurrentAccount:', currentAccount);
      fetchNFTMetadata();
    }
  }, [currentAccount]);

  //Condential Renders

  const renderContent = () => {
    if (isLoading) {
      return <LoadingIndicator />;
    }

    if (!currentAccount) {
      return (
        <div className="connect-wallet-container">
          <button className="cta-button connect-wallet-button" onClick={connectWalletAction} >
            Connect Wallet to Get started
          </button>
        </div>
      );
    } else if (currentAccount && !characterNFT) {
      return <SelectCharacter setCharacterNFT={setCharacterNFT} />;
    } else if (currentAccount && characterNFT) {
      return <Arena characterNFT={characterNFT} setCharacterNFT={setCharacterNFT} />;
    }
  };

  const renderLyrics = () => {
    if (!currentAccount) {
      return (
        <p className="sub-text">
          "We all know the beast, pilgrim <br />
          He lurks out there in the unknown <br />
          Seeking those who are far from home <br />
          Hoping never to let you return"<br />
        </p>
      )
    } else if (currentAccount && !characterNFT) {
      return (
        <p className="sub-text">
          "Ooo, better beware <br />
          Ooo, the beast is out there <br />
          Ooo, better be wise <br />
          And don't believe his lies" <br />
        </p>
      )
    } else if (currentAccount && characterNFT) {
      return (
        <p className="sub-text">
          "For once your will begins to spoil <br />
          He'll turn you to a tree of oil <br />
          And use you in his lantern for to burn" <br />
        </p>
      )
    }
  }



  return (
    <div className="App">
      <video className="bgvideo" autoPlay muted loop >
        <source src={bgvideo} type="video/mp4" />
      </video>
      <div className="container">
        <div className="header-container">
          <p className="header gradient-text">INTO THE UNKNOWN</p>
          {renderLyrics()}
          {renderContent()}
        </div>
        <div className="footer-container">
          <img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
          <a
            className="footer-text"
            href={TWITTER_LINK}
            target="_blank"
            rel="noreferrer"
          >{`built by @${TWITTER_HANDLE}`}</a>
        </div>
      </div>
    </div>
  );
};

export default App;
